module.exports = __webpack_public_path__ + "static/media/instagram-white.7b9af24c.svg";